/* RunAuditComponent.js */

"use strict";
const ConfigureAuditScreenComponent = require("./ConfigureAuditScreenComponent");

class RunAudit {
    constructor({ muf, logger, gameEditor, deviceEntity, userSession, ConfigAuditPolicy }) {
        this._muf = muf;
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._deviceEntity = deviceEntity;
        this._userSession = userSession;
        this._ConfigAuditPolicy = ConfigAuditPolicy;
    }

    setDevice(dev) {
        this._deviceEntity = dev;
    }
    runAllAudits(deviceId, policyIds) {
        this.runAudit(deviceId, policyIds, true);
    }

    runAudit(deviceId, policyIds, all = false) {
        let auditScreenComponent = new ConfigureAuditScreenComponent(
            this._logger,
            this._gameEditor,
            this._deviceEntity,
            this._muf,
            this._userSession,
            policyIds,
            deviceId,
            this._ConfigAuditPolicy,
            all
        );

        return this._muf.displayCustom(auditScreenComponent, { dontHide: false }).catch((err) => {
            if (err && err.userRejected) {
                this._logger.warn({ error: err }, "ConfigAuditAction.run() - User Canceled");
                return;
            } else {
                this._logger.warn({ error: err }, "ConfigAuditAction.run() - Error");
                return this._muf.displayError(err);
            }
        });
    }
}
module.exports = RunAudit;
